export default "__VITE_ASSET__Cazc59t5__"